<template>
  <div
    class="md-layout md-alignment-center-center container gray-6 bg new-globals"
  >
    <org-selector @orgChange="onOrgChange" />
  </div>
</template>

<script>
import OrgSelector from '~lib/common/components/OrgSelector';

export default {
  name: 'org-selection',
  components: { OrgSelector },
  methods: {
    onOrgChange() {
      this.$router.push({ name: 'cases' });
    }
  }
};
</script>

<style scoped>
.container {
  flex-direction: column;
}

.md-layout {
  height: 100%
}
</style>
